var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXrVrGpu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66634 14V3.33333M2.66634 3.33333C2.66634 3.02333 2.66634 2.86867 2.63234 2.74133C2.58688 2.57191 2.49765 2.41743 2.37362 2.29339C2.24958 2.16936 2.0951 2.08013 1.92567 2.03467C1.79701 2 1.64234 2 1.33301 2M2.66634 3.33333H11.333C12.9043 3.33333 13.6897 3.33333 14.1783 3.82133C14.667 4.30933 14.6663 5.09533 14.6663 6.66667V9.66667C14.6663 11.238 14.6663 12.0233 14.1783 12.512C13.6897 13 12.9043 13 11.333 13H8.07834C7.85439 12.9999 7.63488 12.9375 7.44438 12.8198C7.25387 12.702 7.0999 12.5336 6.99967 12.3333C6.79567 11.9247 6.37767 11.6667 5.92101 11.6667H2.66634",
    stroke: "#EE2B2A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 5.66602H6.33333M5 7.66602H6.33333M5 9.66602H6.33333M12.6667 7.66602C12.6667 8.19645 12.456 8.70516 12.0809 9.08023C11.7058 9.4553 11.1971 9.66602 10.6667 9.66602C10.1362 9.66602 9.62753 9.4553 9.25245 9.08023C8.87738 8.70516 8.66667 8.19645 8.66667 7.66602C8.66667 7.13558 8.87738 6.62687 9.25245 6.2518C9.62753 5.87673 10.1362 5.66602 10.6667 5.66602C11.1971 5.66602 11.7058 5.87673 12.0809 6.2518C12.456 6.62687 12.6667 7.13558 12.6667 7.66602Z",
    stroke: "#EE2B2A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXrVrGpu);
export default __webpack_public_path__ + "static/media/xr-vr-gpu.12018d84ec6d043850804e6ae25d92e0.svg";
export { ForwardRef as ReactComponent };